import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class MapService {


  mapUrl = appUrls.map;
  constructor(private http: HttpClient) { }

  //getAllPops() {
  //  return this.http.get(this.mapUrl.getAllpopsData);
  //}
  getAllPopsOfTheseLines(linesList: string[]) {
    return this.http.post(this.mapUrl.getPopsOfLines, linesList);
  }



  getAllLinesOfThisPop(popConvention: string) {
    return this.http.get(this.mapUrl.getLinesOfAPop + popConvention);
  }
  getAllClusteredPop() {
    return this.http.get(this.mapUrl.getClusteredPops );
  }

 



}
